//import Footer from "../../Components/Footer/Footer";
import Culture from "./culture";
import OpenPositions from "./openjob";
import TeamReviews from "./teamreview";

import { useEffect } from "react";

const Career = () => {
  useEffect(() => {
    document.body.classList.add("culture-page");
    return () => {
      document.body.classList.remove("culture-page");
    };
  }, []);

  return (
    <>
      <Culture />
      <TeamReviews />
      <OpenPositions />
      
    </>
  );
};

export default Career;
